import {
	faArrowDown,
	faArrowUp,
	faTimes,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { SelectedColumnProps } from '@/components/ColumnsPicker/types'
import { TableIndexColumn } from '@/endpoints/models'
import { SortIcon } from '@/pages/User/pages/Home/pages/TableDetail/components/SortIcon'

import { Action, CheckBoxField, Column, Name } from './styles'

export const SelectedColumn = ({
	indexColumn,
	index,
	valueLength,
	onUp,
	onDown,
	onRemove,
	onChangeItemSort,
	orders,
}: SelectedColumnProps) => {
	const { payload, rest } = indexColumn || {}

	if (!rest || !payload) return null

	const columnName = rest.name || payload.code

	return (
		<Column key={rest.id}>
			{orders && (
				<SortIcon
					sortType={
						(payload.sortType as TableIndexColumn.SortTypeEnum) ??
						TableIndexColumn.SortTypeEnum.DESC
					}
				/>
			)}
			<Name data-testid={`column_${index}-${columnName}`}>{columnName}</Name>
			<Action $isHidden={index === 0} onClick={() => onUp(payload)}>
				<FontAwesomeIcon icon={faArrowUp} />
			</Action>
			<Action
				$isHidden={index === valueLength - 1}
				onClick={() => onDown(payload)}
			>
				<FontAwesomeIcon icon={faArrowDown} />
			</Action>
			<Action onClick={() => onRemove(payload)}>
				<FontAwesomeIcon icon={faTimes} />
			</Action>
			{orders && (
				<CheckBoxField
					name={'sort' + rest.id}
					initialValue={payload.sortType === TableIndexColumn.SortTypeEnum.DESC}
					onChange={() => onChangeItemSort(payload)}
					title={TableIndexColumn.SortTypeEnum.DESC}
					showTitlePlaceholder={false}
				/>
			)}
		</Column>
	)
}
